import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'

const personalDashboardsubject: BehaviorSubject<Definable<boolean>> = new BehaviorSubject<Definable<boolean>>(false)

RxJS.personalDashboardUpdate = RxJS.personalDashboardUpdate ?? {
    subject: personalDashboardsubject,
    observable: personalDashboardsubject.asObservable(),
    announce: (update?: boolean): void => {
        personalDashboardsubject.next(update)
    }
}

export const personalDashboardUpdate$ = RxJS.personalDashboardUpdate
